module.exports = __webpack_public_path__ + "img/logo2.0ce83779.png";